const migrations = {
  1: state => ({
    oauth: state.oauth || {},
    user: state.user || {},
    session: state.session || {},
  }),
};

export default migrations;
